import { PAYMENT_STATUS, PaymentStatus } from "constants/types/report";

export const REPORT_TAB = {
  PROFIT: "profit",
  COLLECTION: "collection",
  PURCHASE: "purchase",
} as const;

export type ReportTab = (typeof REPORT_TAB)[keyof typeof REPORT_TAB];

export const REPORT_TAB_LABEL: Record<ReportTab, string> = {
  [REPORT_TAB.PROFIT]: "Tình hình bán hàng",
  [REPORT_TAB.COLLECTION]: "Báo cáo chi tiết thu tiền",
  [REPORT_TAB.PURCHASE]: "Tình hình mua hàng",
};

export const PAYMENT_STATUS_LABEL: Record<PaymentStatus, string> = {
  [PAYMENT_STATUS.PENDING]: "Chờ xác nhận",
  [PAYMENT_STATUS.APPROVED]: "Đã xác nhận",
  [PAYMENT_STATUS.COMPLETED]: "Hoàn thành",
  [PAYMENT_STATUS.CANCELLED]: "Đã hủy",
};

export const PAYMENT_STATUS_COLOR: Record<PaymentStatus, string> = {
  [PAYMENT_STATUS.PENDING]: "yellow",
  [PAYMENT_STATUS.APPROVED]: "blue",
  [PAYMENT_STATUS.COMPLETED]: "green",
  [PAYMENT_STATUS.CANCELLED]: "red",
};

export const profitColor = (amount: number): string | undefined =>
  amount > 0 ? "green" : amount < 0 ? "red" : undefined;
